import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";

import { config } from "../constant";
import useRequest from "../../hooks/useRequest";
import DeleteConfirmModal from "./delete-confirm";
import { useContextData } from "../../store/ContextData";

const AddApprovers = (props) => {
  const {approvers, setApprovers, emailColumn} = props;

  const { userId } = useContextData();

  const [allUsers, setAllUsers] = useState([]);
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const [selectedApprover, setSelectedApprover] = useState("");
  const [objectifiedUsers, setObjectifiedUsers] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const {loading, data: usersData} = useRequest("api/v1/getAllUsersUnderOrganization/");
  useEffect(() => {
    if(!loading && usersData){
      const objectifiedUsers = {};
      const usersToSet = usersData.filter(user => user._id !== userId).map((user) => {
        const { _id, name, email } = user;
        objectifiedUsers[_id] = { ...user };
        return {
          value: _id,
          label: `${name} (${email})`
        };
      });
      setAllUsers(usersToSet);
      setObjectifiedUsers(objectifiedUsers);
    }
  }, [userId, loading, usersData]);

  const deleteApprover = useCallback((deleteIndex) => {
    setShowDeleteModal(false);
    setApprovers(oldData => oldData.filter((_, index) => index !== deleteIndex));
    setDeleteIndex(-1);
  }, [setApprovers]);

  return (
    <div className="meta-container">
      <h4 className="meta-heading">Add one or more approvers</h4>
      <p className="sub-heading">
        You can add one or more approvers for the generated document. 
        Once the document is generated, the first approver will receive an email with the document attached.
        Once all the approvers have approved the document, the document will be sent to the specific user.
      </p>
      {
        approvers.map((approverId, index) => {
          const { name, email, role } = objectifiedUsers[approverId];
          return (
            <div className="group-creation" key={`${index}-${approverId}`}>
              <div className="group form-group">
                <div className="group-name">
                  <div className="flex-container vertical-middle">
                    <h4 className="flexbox meta-heading">Approver: {name}</h4>
                    <div className="flexbox buttons">
                      <button className="btn small" onClick={() => {
                        setDeleteIndex(index);
                        setShowDeleteModal(true);
                      }}>Delete</button>
                    </div>
                  </div>
                </div>
                <div className="key-value">
                  <div className="key">Email</div>
                  <div className="value fixed-width">{email}</div>

                  <div className="key">Role</div>
                  <div className="value fixed-width">{config.USER_ROLES[Number(role) - 1]}</div>
                </div>
              </div>
            </div>
          )
        })
      }
      <div className="line-separator"/>
      <div className="form-group has-field">
        <div>
          <label htmlFor="approvers">Select Approvers <span>*</span></label>
          <Select 
            isDisabled={!emailColumn}
            id="approvers" 
            className="input-select" 
            isSearchable={true} 
            placeholder="Select approvers for generated document" 
            name="approvers" 
            options={allUsers}
            value={allUsers.filter(option => option.value === selectedApprover)}
            onChange={(e) => setSelectedApprover(e.value)}
          />
        </div>
        <div className="footer text-right">
          <button
            className="btn moral"
            disabled={!selectedApprover || !emailColumn}
            onClick={() => {
              const aproverId = selectedApprover;
              setApprovers(oldData => {
                const newSet = new Set([...oldData, aproverId]);
                return Array.from(newSet);
              });
              setSelectedApprover("");
            }}
          >Add approver</button>
        </div>
      </div>
      {showDeleteModal && 
        <DeleteConfirmModal
          disableStatus={false}
          desc="The selected approver will be deleted, you can add another approver by selecting approvers."
          buttonText="Delete"
          isLoading={false}
          close={() => {
            setShowDeleteModal(false);
            setDeleteIndex(-1);
          }}
          doDelete={() => deleteApprover(deleteIndex)}
        />
      }
    </div>
  );
}

export default AddApprovers;
